const profileMenuEntries = [
  {
    name: 'My Profile',
    path: '/MyProfile',
  },
  {
    name: 'My Settings',
    path: '/MySettings',
  },
  {
    name: 'Help',
    path: '/Help',
  },
  {
    name: 'Terms and Conditions',
    path: '/Terms',
  },
  {
    name: 'Logout',
    path: '/Logout',
  },
];

export default profileMenuEntries;
